export function cpfMask(cpfValue) {
  cpfValue = cpfValue.replace(/\D/g, '')
  cpfValue = cpfValue.replace(/(\d{3})(\d)/, '$1.$2')
  cpfValue = cpfValue.replace(/(\d{3})(\d)/, '$1.$2')
  cpfValue = cpfValue.replace(/(\d{3})(\d{1,2})$/, '$1-$2')
  return cpfValue
}
